module.exports = __webpack_public_path__ + "img/2900f.e190bee5.png";